<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title>
        연령대
        <span class="asterisk">*</span>
      </v-list-item-title>
      <v-select
        solo
        required
        ref="refAge"
        label="연령대"
        :items="itemsAge"
        :height="formHeight"
        v-model="userData.birthdayType"
      />
    </v-list-item-content>
  </v-list-item>
</template>
<script>
const rulesService = require("@/utils/rules.js");
const formatService = require("@/utils/format.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      itemsAge: formatService.age(),
    };
  },
};
</script>
<style lang="">
</style>